import orderDataService from "@/store.order/services/main-service.js";
import shoppingCartDataService from "@/store.shoppingCart/services/main-service.js";
import userInfoService from "@/app.user/services/main-service.js";

function ShoppingCart(){
    this.items = [], 
    this.info = {
        count : 0
    };
    this.getInfo = async function(){
        var userInfo = userInfoService.getCurrentUserInfo()
        if (userInfo && userInfo.id){
            try{
                //const {data} = await shoppingCartDataService.getByUserId(userInfo.id);
                const items = await this.getItems()

                //this.info.count = data.length;
                this.info.count = items.length;
    
                return this.info;
            }catch(error){
                console.error(error);
            }
        }else{
            this.info = {
                count: 0
            };

            return this.info;
        } 
    };
    this.getItems = async function(){
        let userInfo = userInfoService.getCurrentUserInfo();

        try{
            const {data} = await shoppingCartDataService.getByUserId(userInfo.id);
            this.items = data || [];

            return this.items;
        }catch(error){
            console.error(error);
        }

        return this.items;
    };
    this.isAlreadyInCart = async function(productId){
        let userInfo = userInfoService.getCurrentUserInfo();
        try{
            const {data} = await shoppingCartDataService.isAlreadyInCart(userInfo.id, productId)
            return data;
        }
        catch(error){
            console.error(error);
        }

    };
    this.getById = function(id){
        return this.items.find(e=>e.id===id);
    };
    this.add = function(item, productId){
        let userInfo = userInfoService.getCurrentUserInfo();

        if(item && item.id){
            //let index = this.items.findIndex(e => e.id == item.id);
            //product re-added from product detail page
            //id => shoppingCartId
            //productId => productId
            let index = this.items.findIndex(e => e.productFk == productId);

            if(index > -1){

                var shoppingCartItem = this.items[index];
                //Update current itemId from productTo shoppingCartId

                this.items[index].count += item.count; //Add the defined quantity

                //Update
                return shoppingCartDataService.update(
                    {
                        id: shoppingCartItem.id,
                        userFk: userInfo.id,
                        productFk: productId,
                        count: this.items[index].count,
                        totalCost: item.totalCost, 
                        remarks: item.remarks,
                        uomFk: item.uomFk,
                        isStandard: item.isStandard,
                        version: item.version,
                        createdOn: item.createdOn
                    });

            }else{
                let itemCopy = Object.assign({}, item);
                this.items.push(itemCopy);
                ++this.info.count;

                //Add
                return shoppingCartDataService.create(
                    {
                        userFk: userInfo.id,
                        productFk: item.id,
                        count: item.count,
                        totalCost: item.totalCost, 
                        remarks: item.remarks,
                        uomFk: item.uomFk,
                        isStandard: item.isStandard,
                        version: 0
                    });
            }
        }

        return Promise.resolve();
    };
    this.updateShoppingCart = function(item){
        return shoppingCartDataService.update(item);
    };
    this.delete = async function(item){
        if(item && item.id){
            let index = this.items.findIndex(e => e.id == item.id);
            if(index > -1){
                this.items.splice(index, 1);
                --this.info.count;
                
                //Delete from Db
                await shoppingCartDataService.delete(item);
            }
        }
    };
    this.reduce = function(item){
        if(item && item.id){
            let index = this.items.findIndex(e => e.id == item.id);
            if(index > -1){
                if(this.items[index].count > 1){
                    this.items[index].count -= 1;
                }else{
                    this.items.splice(index, 1);
                    --this.info.count;
                }
            }
        }
    };
    this.submit = function(userId, comments, shippingFee/*, callback*/){
        let products = [];
        this.items.forEach(function(item){
            var productItem = item;
            productItem.id = item.product.id;
            productItem.count = item.count;
            products.push(productItem);
        });

        let orderDetail = {
            UserId : userId,
            Comments: comments,
            ShippingCode: shippingFee,
            Products : products
        };

        return orderDataService.addOrder(orderDetail);
    };
    this.clear = function(){
        this.items.splice(0, this.info.count);
        this.info.count = 0;
    }
}

const shoppingCart = new ShoppingCart();

export default shoppingCart;
